import { Component, Input, ViewChild } from '@angular/core';
import { CardType, IPropertyCard } from '../../_core/interfaces/IPropertyCard';
import { ProjectService } from '../../_core/services/project.service';
import { RoofService } from '../../_core/services/areas/roof.service';
import { LocationService } from '../../_core/services/location.service';
import { NumTbxComponent } from 'src/app/_shared/numeric-textbox/num-tbx.component';
import { FrameMode, FrameProfile } from 'src/app/_core/models/profiles/frame.model';

@Component({
	selector: 'card-frame',
	templateUrl: './card-frame.component.html',
	styleUrls: ['../card.component.css']
})
export class CardFrameComponent implements IPropertyCard {
	@ViewChild('numLoc', { static: false }) numLoc: NumTbxComponent;

	@Input() public set items(items: any[] | null) {
		if (items !== null) {
			this.current = items[0];
		}
	}

	public type: CardType = CardType.FrameProfile;
	public current: FrameProfile;

	constructor(
		public projectService: ProjectService,
		protected roofService: RoofService,
		protected locationService: LocationService,
	) { }

	get currentProfileLocation() {
		return this.locationService.getLocation(this.current);
	}

	// Profile

	delete() {
		this.current.mode = FrameMode.Off;
	}


	get currLng(): string {
		return window.document.documentElement.lang;
	}

}
